import { render, staticRenderFns } from "./MallShopping.vue?vue&type=template&id=495bc1e4&scoped=true&"
import script from "./MallShopping.vue?vue&type=script&lang=js&"
export * from "./MallShopping.vue?vue&type=script&lang=js&"
import style0 from "./MallShopping.vue?vue&type=style&index=0&id=495bc1e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495bc1e4",
  null
  
)

export default component.exports